import axiosInstance from './axiosInstance';
import { User } from '../models/worker';

export const fetchRecruitmentUsersRequest = async (): Promise<User[]> => {
    const response = await axiosInstance.get<User[]>('/users/recruitment');
    return response.data;
};

export const usersApi = {
    getRecruitmentUsers: async (): Promise<User[]> => {
        const response = await axiosInstance.get<User[]>('/users/recruitment');
        return response.data;
    },
    
    syncUsersFromKeycloak: async (): Promise<{ message: string; count: number }> => {
        const response = await axiosInstance.get<{ message: string; count: number }>('/users/sync');
        return response.data;
    },
    
    getUserById: async (id: number): Promise<User> => {
        const response = await axiosInstance.get<User>(`/users/${id}`);
        return response.data;
    },
};
